module.exports = __webpack_public_path__ + "media/ping.44f44ca8.mp3";